/**
 *  RaceAvatar
 *
 *  Created by Legman on 09/05/2017.
 *
 */

import Common from "./Common";
import Powerup from "./powerups/Powerup";

export default class RaceAvatar extends PIXI.Container {
    /**
     * @param {number} id
     * @param {PIXI.Texture} texture
     * @param {RaceCar} car
     */
    constructor(id, texture, car) {
        super();

        /**
         * @type {number}
         */
        this.lastRacePos = 0;

        /**
         * @type {number}
         * @private
         */
        this._id = id;

        /**
         * @type {RaceCar}
         * @private
         */
        this._car = car;

        /**
         * @type {PIXI.Texture}
         * @private
         */
        this._texture = texture;

        /**
         * @type {PIXI.Container}
         */
        this.view = new PIXI.Container();
        this.addChild(this.view);

        const assets = Common.assets;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._hit = new PIXI.Sprite(assets.getTexture("ui_icon_char_hit"));
        this._hit.anchor = new PIXI.Point(0.5, 0.5);
        this._hit.visible = false;
        this.view.addChild(this._hit);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._player = new PIXI.Sprite(assets.getTexture("ui_icon_char_player_bg"));
        this._player.anchor = new PIXI.Point(0.5, 0.5);
        this._player.visible = this._car.isPlayer;
        this.view.addChild(this._player);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._character = new PIXI.Sprite(texture);
        this._character.anchor = new PIXI.Point(0.5, 0.5);
        this.view.addChild(this._character);

        /**
         * @type {PIXI.BitmapText}
         */
        //this._racePosLabel = new PIXI.BitmapText("0", font(32, "left"));
        this._racePosLabel = new PIXI.BitmapText("0", {font: "32px Antique Olive Std", align: "left"});
        this._racePosLabel.x = -4;
        this._racePosLabel.pivot.x = this._racePosLabel.textWidth * 0.5;
        this._racePosLabel.pivot.y = this._racePosLabel.textHeight * 0.5;
        this.view.addChild(this._racePosLabel);
    }

    /**
     * @param {number} type
     * @param {boolean} [hit=false]
     */
    usePowerup(type, hit = false) {
        const icon = new PIXI.Sprite(Powerup.getTexture(type));
        icon.x = 60;
        icon.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(icon);

        const tl = new TimelineMax();

        icon.scale = new PIXI.Point();
        tl.append(TweenMax.to(icon.scale, 0.32, {
            x: 0.4,
            y: 0.4,
            ease: Back.easeOut,
            easeParams: [4]
        }));
        tl.append(TweenMax.to(icon.scale, 0.2, {
            delay: 0.4,
            x: 0,
            y: 0,
            ease: Back.easeIn
        }));

        if (hit) {
            const tl = new TimelineMax();
            tl.append(TweenMax.to(this.view.scale, 0.2, {
                x: 1.24,
                y: 1.24,
                ease: Power0.easeNone
            }));
            tl.append(TweenMax.to(this.view.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Power2.easeOut
            }));

            this._hit.alpha = 0;
            this._hit.visible = true;
            TweenMax.to(this._hit, 0.2, {
                alpha: 1,
                ease: Power2.easeInOut,
                yoyo: true,
                repeat: 3,
                onComplete: function() {
                    this._hit.visible = false;
                },
                onCompleteScope: this
            });
        }
    }

    /**
     * @param {number} value
     */
    setRacePos(value) {
        this._racePosLabel.text = value.toString();
        this._racePosLabel.validate();
        this._racePosLabel.pivot.x = this._racePosLabel.textWidth * 0.5;
        this._racePosLabel.pivot.y = this._racePosLabel.textHeight * 0.5;
    }

    /**
     * @returns {number}
     */
    get id() {
        return this._id;
    }

    /**
     * @returns {RaceCar}
     */
    get car() {
        return this._car;
    }
}